interface PendingRequestsIndicatorProps {
  readonly className?: string;
}

// Component disabled - offline functionality removed
export const PendingRequestsIndicator = ({
  className = '',
}: Readonly<PendingRequestsIndicatorProps>) => {
  return null;
};
